module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy-title"
  }, [_vm._v("AN ASSISTANT PROFESSOR")]), _vm._v(" "), _c('p', {
    staticClass: "copy-title1"
  }, [_vm._v("A NOVEL OF SORTS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("© 2016 "), _c('span', {
    staticClass: "copys"
  }, [_vm._v("Adeeb Yusef Salam")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other‚—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This is a work of fiction. Names, characters, businesses, places, events, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published in New York, New York, by Morgan James Publishing. Morgan James and The Entrepreneurial Publisher are trademarks of Morgan James, LLC."), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.MorganJamesPublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.MorganJamesPublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The Morgan James Speakers Group can bring authors to your live event. For more information or to book an event visit The Morgan James Speakers Group at"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.TheMorganJamesSpeakersGroup.com",
      "target": "_blank"
    }
  }, [_vm._v("www.TheMorganJamesSpeakersGroup.com")]), _vm._v(".")]), _vm._v(" "), _c('table', {
    staticClass: "table-top"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "width45m mid"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "images/copy1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "width45"
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-1-68350-090-2 paperback"), _c('br'), _vm._v("ISBN 978-1-68350-092-6 eBook"), _c('br'), _vm._v("ISBN 978-1-68350-091-9 hardcover"), _c('br'), _vm._v("Library of Congress Control Number:"), _c('br'), _vm._v("2016908308")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cover Design by:")]), _c('br'), _vm._v("Megan Whitney"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:megan@creativeninjadesigns.com"
    }
  }, [_vm._v("megan@creativeninjadesigns.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Interior Design by:")]), _c('br'), _vm._v("Bonnie Bushman"), _c('br'), _vm._v("The Whole Caboodle Graphic Design")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("In an effort to support local communities, raise awareness and funds, Morgan James Publishing donates a percentage of all book sales for the life of each book to Habitat for Humanity Peninsula and Greater Williamsburg.")]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("Get involved today! Visit"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.MorganJamesBuilds.com",
      "target": "_blank"
    }
  }, [_vm._v("www.MorganJamesBuilds.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab917010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 63
// module chunks = 0